module.exports = __webpack_public_path__ + "static/img/silver 2.2f540a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/silver 2.png
// module id = zi4M
// module chunks = 35